import { ArrowBendDownRight } from '@phosphor-icons/react';

export default ArrowBendDownRight;
